import * as faceapi from "@vladmandic/face-api";

const MODEL_URL = "/models";
let _loaded = false;
let _loading = null;

export async function loadModels() {
  if (_loaded) return;
  if (_loading) return _loading;
  _loading = Promise.all([
    faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
    faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
    faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
  ]).then(() => { _loaded = true; });
  return _loading;
}

// Returns { descriptor:[128 floats], score } or { error: 'no_face'|'multiple'|'low_quality' }
export async function detectDescriptor(video) {
  const opts = new faceapi.TinyFaceDetectorOptions({ inputSize: 416, scoreThreshold: 0.5 });
  const all = await faceapi.detectAllFaces(video, opts).withFaceLandmarks().withFaceDescriptor();
  if (!all || all.length === 0) return { error: "no_face" };
  if (all.length > 1) return { error: "multiple" };
  const det = all[0];
  if (det.detection.score < 0.55) return { error: "low_quality" };
  return { descriptor: Array.from(det.descriptor), score: Number(det.detection.score.toFixed(3)) };
}
